import { useCallback, useEffect, useState } from 'react';
import { isFormDirty, normalizePhoneDigits } from './configFormValidators';

export const useConfigForm = ({ initialValues, validate }) => {
  const [formState, setFormState] = useState(null);
  const [originalFormState, setOriginalFormState] = useState(null);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (initialValues) {
      setFormState(initialValues);
      setOriginalFormState(initialValues);
      setErrors({});
    }
  }, [initialValues]);

  const handleInputChange = useCallback((event) => {
    const { name, value } = event.target;
    let newValue = value;

    if (['supportNumber', 'faxNumberInbound'].includes(name)) {
      newValue = normalizePhoneDigits(value);
    }

    setFormState((prevState) => ({
      ...prevState,
      [name]: newValue,
    }));

    setErrors((prevErrors) => {
      if (!prevErrors[name]) return prevErrors;
      const next = { ...prevErrors };
      delete next[name];
      return next;
    });
  }, []);

  const handleCheckboxChange = useCallback((event) => {
    const { name, checked } = event.target;
    setFormState((prevState) => ({
      ...prevState,
      [name]: checked,
    }));
  }, []);

  const resetForm = useCallback((values) => {
    setFormState(values);
    setOriginalFormState(values);
    setErrors({});
  }, []);

  const runValidation = useCallback(() => {
    if (!validate || !formState) return true;
    const nextErrors = validate(formState);
    setErrors(nextErrors);
    return Object.keys(nextErrors).length === 0;
  }, [formState, validate]);

  const isDirty = isFormDirty(formState, originalFormState);

  return {
    formState,
    originalFormState,
    errors,
    isDirty,
    handleInputChange,
    handleCheckboxChange,
    resetForm,
    runValidation,
  };
};
